import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '../../lib/cn';

export interface MarkdownProps {
  children: string;
  className?: string;
}

export function Markdown({ children, className }: MarkdownProps) {
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none',
        'prose-headings:font-semibold prose-headings:text-tg-text',
        'prose-h1:text-lg prose-h1:mt-0 prose-h1:mb-3',
        'prose-h2:text-base prose-h2:mt-4 prose-h2:mb-2',
        'prose-h3:text-sm prose-h3:mt-3 prose-h3:mb-1',
        'prose-p:my-2 prose-p:leading-relaxed prose-p:text-sm prose-p:text-tg-text',
        'prose-strong:font-semibold prose-strong:text-tg-text',
        'prose-em:text-tg-text',
        'prose-ul:my-2 prose-ul:pl-5 prose-ol:my-2 prose-ol:pl-5',
        'prose-li:my-0.5 prose-li:text-sm prose-li:text-tg-text',
        'prose-a:text-tg-link prose-a:no-underline hover:prose-a:underline',
        'prose-blockquote:border-l-2 prose-blockquote:border-tg-hint/40 prose-blockquote:pl-3 prose-blockquote:italic prose-blockquote:text-tg-text/80',
        'prose-code:text-xs prose-code:bg-tg-section-bg prose-code:px-1 prose-code:py-0.5 prose-code:rounded',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
